module.exports = ".BigButton{width:30%;height:50px;margin-top:15px}.red{color:#c33c3c}.green{color:#00a100}\n"